(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
		constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.section-header');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
		this.headerBounds = {};

		this.setHeaderHeight();

		window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

		// Add resize listener to handle announcement bar height changes
		window.addEventListener('resize', this.updateStickyPosition.bind(this));

		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-sticky');
			// Small delay to ensure DOM is fully loaded
			setTimeout(() => this.updateStickyPosition(), 100);
		};

		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
		this.createAnnouncementBarObserver();
	}

	setHeaderHeight() {
		document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
		this.updateStickyPosition();
	}

	updateStickyPosition() {
		let stickyTop = 0;

		// For navigation bar
		const announcementBar = document.querySelector('.announcement-bar-section');
		if (announcementBar && announcementBar.offsetHeight > 0) {
			stickyTop = announcementBar.offsetHeight;
		}
		// Only update if the value has changed
		const currentHeight = getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height');
		const newHeight = `${stickyTop}px`;
		if (currentHeight !== newHeight) {
			document.documentElement.style.setProperty('--announcement-bar-height', newHeight);
			// Update the sticky header position
			if (this.header.classList.contains('shopify-section-header-sticky')) {
				this.header.style.top = newHeight;
			}
		}

		// For perks list
		const navigationBar = document.querySelector('.navigation-bar-section');
		if (navigationBar && navigationBar.offsetHeight > 0) {
			stickyTop = stickyTop + navigationBar.offsetHeight;
		}
		// Only update if the value has changed
		const currentHeightPerkList = getComputedStyle(document.documentElement).getPropertyValue('--navigation-bar-height');
		const newHeightPerkList = `${stickyTop}px`;
		if (currentHeightPerkList !== newHeightPerkList) {
			document.documentElement.style.setProperty('--navigation-bar-height', newHeightPerkList);
			// Update the sticky perks list position
			const stickyPerksList = document.querySelector('.shopify-section-group-header-group.section-perk-list')
			if (stickyPerksList) {
				stickyPerksList.classList.add('shopify-section-perk-list-sticky')
				stickyPerksList.style.top = newHeightPerkList;
			}

      // Get the height of the sticky perks list and set as a CSS variable
      function updateStickyPerksListHeight() {
        if (!stickyPerksList) return;
        requestAnimationFrame(() => { // Waits until the browser has calculated the layout and then sets the number
          const stickyPerksListHeight = stickyPerksList.offsetHeight + 'px';
          document.documentElement.style.setProperty('--sticky-perks-list-height', stickyPerksListHeight);
        });
      }
      updateStickyPerksListHeight();
      // Update on screen resize
      window.addEventListener('resize', updateStickyPerksListHeight);

		}
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
		window.removeEventListener('resize', this.updateStickyPosition.bind(this));

		if (this.announcementBarObserver) {
			this.announcementBarObserver.disconnect();
		}
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
			this.headerBounds = entries[0].intersectionRect;
			observer.disconnect();
		});

		observer.observe(this.header);
	}

	createAnnouncementBarObserver() {
		// Observe changes to the announcement bar section
		const targetNode = document.body;
		const config = { childList: true, subtree: true };

		const callback = (mutationsList, observer) => {
			for (const mutation of mutationsList) {
				if (mutation.type === 'childList') {
					for (const node of mutation.addedNodes) {
						if (node.nodeType === Node.ELEMENT_NODE) {
							if (node.classList && node.classList.contains('announcement-bar-section')) {
								this.updateStickyPosition();
								break;
							}
							if (node.querySelector && node.querySelector('.announcement-bar-section')) {
								this.updateStickyPosition();
								break;
							}
						}
					}
					for (const node of mutation.removedNodes) {
						if (node.nodeType === Node.ELEMENT_NODE) {
							if (node.classList && node.classList.contains('announcement-bar-section')) {
								this.updateStickyPosition();
								break;
							}
							if (node.querySelector && node.querySelector('.announcement-bar-section')) {
								this.updateStickyPosition();
								break;
							}
						}
					}
				}
			}
		};

		this.announcementBarObserver = new MutationObserver(callback);
		this.announcementBarObserver.observe(targetNode, config);
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			document.documentElement.classList.add('scrolled-past-header');

			if (this.preventHide) return;

			requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			document.documentElement.classList.add('scrolled-past-header');

			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);
				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);
				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerBounds.top) {
			document.documentElement.classList.remove('scrolled-past-header');
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
		this.closeSearchModal();

		// Update sticky position when header becomes sticky
		this.updateStickyPosition();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');

		// Set the correct top position based on announcement bar
		const announcementBar = document.querySelector('.announcement-bar-section');
		let stickyTop = 0;

		if (announcementBar && announcementBar.offsetHeight > 0) {
			stickyTop = announcementBar.offsetHeight;
		}

		this.header.style.top = `${stickyTop}px`;
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		this.header.style.top = '';
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
		this.disclosures.forEach(disclosure => disclosure.close());
	}

	closeSearchModal() {
		this.searchModal = this.searchModal || this.header.querySelector('details-modal');
		this.searchModal.close(false);
	}
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
